module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-item",
    style: (_vm.style),
    on: {
      "click": _vm.handleClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-119a08ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/carousel-item.vue
// module id = 224
// module chunks = 15